import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiEmbeddedLeadFormInput' })(
  ({ brandType, brandColors, breakpoints, type, typography }) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: typography.pxToRem(10),
    },
    formLabel: {
      marginBottom: typography.pxToRem(11),
      ...type['20_regular'],
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
      },
    },
    input: {
      border: `0.5px solid ${brandColors.lightGray} `,
      height: typography.pxToRem(41),
      paddingLeft: typography.pxToRem(16),
      paddingRight: typography.pxToRem(16),
      fontSize: typography.pxToRem(16),
      lineHeight: typography.pxToRem(22),
    },
    error: {
      marginTop: typography.pxToRem(4),
      height: typography.pxToRem(16),
      color: brandColors.errorMain,
      ...brandType['body-s'],
    },
  })
);

export default useStyles;
